import * as React from "react";
import createSvgIcon from "./utils/create_svg_icon";

export default createSvgIcon(
  <path d="M 15.539062 15.367188 L 0.539062 15.367188 L 8.039062 0.367188 Z M 2.15625 14.367188 L 13.921875 14.367188 L 8.039062 2.601562 Z M 8.539062 6.367188 L 8.539062 11.367188 L 7.539062 11.367188 L 7.539062 6.367188 Z M 7.539062 12.367188 L 8.539062 12.367188 L 8.539062 13.367188 L 7.539062 13.367188 Z M 7.539062 12.367188 " />,
  "Warning",
);
